








































# import settings from '@/settings'
import t from '@/utils/tools'
import q from '@/graphql/query'
import Menus from '@/components/menus'

export default {
    name: 'company_users_informations'

    components: { Menus }
     
    props:
        uid:
            type: String
            default: '0'
        direct:
            type: Boolean
            default: false

    watch:
        '$route': (to, from)->
            # console.log "WATCH ROUTE", to,
            if to.name == 'company_users_pay_slips'
                @remu_class = 'active'
            else
                @remu_class = ''

        'uid': (newId, oldId)->
            # console.log "ROUTER CHANGE ", newId, oldId
            @define_route()

    data: ()->
        remu_class: ''
        informations_accesses: ['users_show', 'user_vouchers_show', 'users_jobs_show', 'user_salaries_show', 'graduates_show', 'users_skills_show']
        informations_routes: ['company_users_profile', 'company_users_vouchers', 'company_users_jobs', 'company_users_salaries', 'company_users_graduates', 'company_users_skills']
        user: null

    computed:
        app_user_fullname: ()->
            if @uid != "0"
                return @$store.getters.current_app_user.firstname+' '+@$store.getters.current_app_user.lastname
            return ''

    methods:
        has_access_right: t.has_access_right

        define_route: ()->
            for index, a of @informations_accesses
                if @has_access_right(a)
                    @$router.push({name:@informations_routes[index], params:{uid:@uid}})
                    .catch (err)-> {}
                    break

    mounted: ()->
        self = @
        #console.log( "COLLABORATEUR INFORMATION MOUNTED", @uid, @direct, @$store.getters.current_app_user)
        if !@direct
            @define_route()
        q.run('get_user', [@uid])
            .then (resp)->
                console.log(resp)
                self.user = resp.body.data.app_user
}
